<template>
  <div class="wrapper">
    <div>
      <CButton color="info" @click="openNew">
        <b>Add New Banner</b>
      </CButton>

      <CRow class="mt-3">
        <CCol sm="12">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <Datatable
                    :items="items"
                    :fields="fields"
                    :meta="meta"
                    :btn_show="true"
                    :btn_edit="true"
                    :btn_deactivate="true"
                    :btn_reactivate="true"
                    :btn_destroy="false"
                    :is_uuid="false"
                    :is_search_by_date="false"
                    @per_page="handlePerPage"
                    @pagination="handlePagination"
                    @search="handleSearch"
                    @sort="handleSort"
                    @is_active="handleIsActive"
                    @showBanner="handleShowBanner"
                    @editBanner="handleEditBanner"
                    @deactivateBanner="handleDeactivate"
                    @reactivateBanner="handleReactivate"
                    @reactivateArticle="handleReactivate"
                  />
                </div>
              </div>
            </div>
          </div>
        </CCol>
      </CRow>

      <alertmodal />
    </div>
  </div>
</template>

<script>
import Datatable from '@/components/datatables_banner.vue'
import banner from '@/services/banner'
import alertmodal from '@/views/alert/modal.vue'
import EventBus from '@/eventBus'
import store from '@/store.js'

export default {
  name: 'banner',
  components: { alertmodal, Datatable },
  data() {
    return {
      fields: [
        { key: 'title', sortable: false },
        { key: 'is_active', sortable: false },
        { key: 'action', label: 'Action', sortable: false },
      ],
      items: [],
      meta: {
        total: 0,
        current_page: 1,
        per_page: 10,
        from: 0,
        to: 0,
        is_active: 1,
      },
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'title',
      sortByDesc: false,
      is_active: 1,
      loading: false,
    }
  },

  mounted() {
    this.loadData()
    EventBus.$on('TABLE_UPDATE_BANNER', this.handleTableUpdate)
  },

  beforeDestroy() {
    EventBus.$off('TABLE_UPDATE_BANNER', this.handleTableUpdate)
  },

  methods: {
    handleTableUpdate(flag) {
      if (flag) {
        this.loadData()
      }
    },

    hasPermission(keys) {
      const permissionList = store.state.user.authenticated.permission
      if (!permissionList) {
        return false
      }
      return keys.some((key) => permissionList.indexOf(key) !== -1)
    },

    notifyUnauthorized() {
      const params = { title: 'Error', mode: 'danger', data: 'unautenticated' }
      EventBus.$emit('OPEN_MODAL_ALERT', params)
    },

    openNew() {
      if (this.hasPermission(['Create/edit banner', 'Create/edit article'])) {
        this.$router.push({ name: 'Banner Form' })
      } else {
        this.notifyUnauthorized()
      }
    },

    openShow(id) {
      if (this.hasPermission(['View banner', 'View article'])) {
        this.$router.push({ name: 'Banner Form', query: { id } })
      } else {
        this.notifyUnauthorized()
      }
    },

    openEdit(id) {
      if (this.hasPermission(['Create/edit banner', 'Create/edit article'])) {
        this.$router.push({ name: 'Banner Form', query: { id } })
      } else {
        this.notifyUnauthorized()
      }
    },

    deactivateBanner(id) {
      if (!this.hasPermission(['Create/edit banner', 'Create/edit article'])) {
        this.notifyUnauthorized()
        return
      }
      if (!confirm('Do you really want to deactivate this banner?')) {
        return
      }
      banner.deactivateBanner(id)
        .then((res) => {
          EventBus.$emit('TABLE_UPDATE_BANNER', true)
          const params = { title: 'Success', mode: 'success', data: res.message }
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        .catch((err) => {
          const message = err.response && err.response.data
            ? err.response.data.message
            : err.message
          const params = { title: 'Error', mode: 'danger', data: message }
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
    },

    reactivateBanner(id) {
      if (!this.hasPermission(['Create/edit banner', 'Create/edit article'])) {
        this.notifyUnauthorized()
        return
      }
      if (!confirm('Do you really want to reactivate this banner?')) {
        return
      }
      banner.reactivateBanner(id)
        .then((res) => {
          EventBus.$emit('TABLE_UPDATE_BANNER', true)
          const params = { title: 'Success', mode: 'success', data: res.message }
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        .catch((err) => {
          const message = err.response && err.response.data
            ? err.response.data.message
            : err.message
          const params = { title: 'Error', mode: 'danger', data: message }
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
    },

    loadData() {
      this.loading = true
      const params = {
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC' : 'ASC',
        is_active: this.is_active,
      }

      banner.getBannerDataSource(params)
        .then((res) => {
          const dataSection = res && res.data ? res.data : res
          const records = dataSection && Array.isArray(dataSection.data)
            ? dataSection.data
            : []
          this.items = records

          this.meta = {
            total: dataSection && dataSection.total ? dataSection.total : records.length,
            current_page: dataSection && dataSection.current_page ? dataSection.current_page : this.current_page,
            per_page: dataSection && dataSection.per_page ? dataSection.per_page : this.per_page,
            from: dataSection && dataSection.from ? dataSection.from : records.length ? 1 : 0,
            to: dataSection && dataSection.to ? dataSection.to : records.length,
            is_active: typeof res.is_active !== 'undefined' ? res.is_active : this.is_active,
          }

          this.current_page = this.meta.current_page
          this.per_page = this.meta.per_page
        })
        .catch((err) => {
          const message = err.response && err.response.data
            ? err.response.data.message
            : err.message
          const params = { title: 'Error', mode: 'danger', data: message }
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        .finally(() => {
          this.loading = false
        })
    },

    handlePerPage(val) {
      this.per_page = val
      this.meta.per_page = val
      this.loadData()
    },

    handlePagination(val) {
      this.current_page = val
      this.meta.current_page = val
      this.loadData()
    },

    handleSearch(val) {
      this.search = val
      this.current_page = 1
      this.meta.current_page = 1
      this.loadData()
    },

    handleSort(val) {
      this.sortBy = val.sortBy
      this.sortByDesc = val.sortDesc
      this.loadData()
    },

    handleIsActive(val) {
      this.is_active = val
      this.current_page = 1
      this.meta.current_page = 1
      this.loadData()
    },

    handleShowBanner(id) {
      this.openShow(id)
    },

    handleEditBanner(id) {
      this.openEdit(id)
    },

    handleDeactivate(id) {
      this.deactivateBanner(id)
    },

    handleReactivate(id) {
      this.reactivateBanner(id)
    },
  },
}
</script>
